export default __webpack_public_path__ + "static/media/mouth.a5f8ef56.svg";